import React from "react";
import { Grid } from "react-bootstrap";
export const Container = ({ children, fluid = false, className, }) => {
    return (React.createElement(Grid, { fluid: fluid, className: className }, children));
};
